export default __webpack_public_path__ + "assets/cuba-flag.png";